export enum LoanOriginationSystemCreateBorrowerTypes {
  CreateBorrower = 'loanOriginationSystemCreateBorrower/createBorrower',
  CreateBorrowerSuccess = 'loanOriginationSystemCreateBorrower/createBorrowerSuccess',
  CreateBorrowerFailure = 'loanOriginationSystemCreateBorrower/createBorrowerFailure',
}
